export default {"src":"/evde-internet/_next/static/media/hşy.23374477.svg","height":42,"width":42};